import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getAllReportsList, getPersonaCategories, getPoolingTime, getReports, sendEmailReports } from "../../core/services/api/reportsService";
import { MocUserRole } from "../../core/services/models/Enums";
import "./ReportView.scss";
import Select from "react-select";
import Toast from "components/Toast";
import fileUtils from "fileUtils";
import moment from "moment";
import { getReportData } from "core/services/api";
// import { Popover, MenuItem } from "@mui/material"

const ReportsView: React.FunctionComponent<any> = () => {
  const userRole = useSelector((state: any) => state?.user?.role)
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [selected, setSelected] = useState<any>("")
  const [intervalId, setIntervalId] = useState<any>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [category, setCategory] = useState<any>({
    categoryName: "",
    reports: [],
  })
  //System Admin specific states
  const [selectedPersona, setSelectedPersona] = useState<any>("")
  const [systeAdminCategories, setSystemAdminCategories] = useState<any>([])
  //Export As Code 
  // const [anchorEl, setAnchorEl] = useState<any>(null);
  // const open = Boolean(anchorEl)
  // const id = open ? 'simple-popover' : undefined;
  const [exportoptions, setExportOptions] = useState<any>([
    { label: "Send as PDF", checked: false },
    { label: "Send as XLSX", checked: false }
  ])
  const [isLoaded, setIsLoaded] = useState<any>(false);
  const [filtersApplied, setFiltersApplied] = useState<any>({})
  const [disableDownload, setDisableDownload] = useState<any>(false);

  const iframeRef: any = useRef(null)
  var value: any;
  const element = document.getElementById("container-wrapper-report")

  useEffect(() => {
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])

  useEffect(() => {
    const messageListener = (event: any) => {
      // Handle the API call event here
      console.log('Received message:', event?.data);
      const eventData: any = event?.data
      if (eventData?.metabase?.type === "location") {
        if (Object.keys(eventData?.metabase?.location)?.includes("search")) {
          const paramsObject = retrieveFiltersFromQueryString(eventData?.metabase?.location?.search);
          if (paramsObject) {
            setFiltersApplied(paramsObject)
          }
        }
      }
      setIsLoaded(false)
      setTimeout(() => {
        setIsLoaded(true)
      }, 0)
    };

    // Add event listener to listen for messages
    window.addEventListener('message', messageListener);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('message', messageListener);
    };
  }, [])

  useEffect(() => {
    value = getRole()
    if (value === "SYSTEM_ADMIN") {
      getPersonaCategories()
        .then((res: any) => {
          const temp = res?.data?.map((ele: any) => {
            return { label: getCategoryLabel(ele), value: ele }
          })
          setSystemAdminCategories(temp)
        })
        .catch((err: any) => console.log(err?.message))
    } else {
      getReportsList(value)
    }
  }, [userRole])

  useEffect(() => {
    getReportsList(selectedPersona)
  }, [selectedPersona])

  const getCategoryLabel = (label: any) => {
    return label?.split("_")?.join(" ")
  }

  const getRole = () => {
    switch (userRole) {
      case 'FRONT_DESK':
        return "FRONT_DESK"
      case "NUTRITIONIST":
        return "NUTRITIONIST"
      case "RMO":
        return "RMO"
      case "MRD":
        return "MRD"
      case "MARKETING":
        return "MARKETING"
      case "QUALITY":
        return "QUALITY"
      case "INSURANCE":
        return "INSURANCE"
      case "CONSULTANT":
        return "CONSULTANT"
      case "ACCOUNTANT":
        return "ACCOUNTANT"
      case "MANAGEMENT":
        return "MANAGEMENT"
      case "BILL_DESK":
        return "FRONT_DESK"
      case "SYSTEM_ADMIN":
        return "SYSTEM_ADMIN"
      case "CENTER_ADMIN":
        return "CENTER_ADMIN"

      default:
        return null
    }
  }

  let [results, setResults] = useState<any>({
    "name": "",
    "iframe": "",
    "questionNumber": 11,
    "dashboardNumber": 1
  })

  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Access the iframe DOM element here if necessary.
      setIsLoaded(true);
    }
  }

  useEffect(() => {
    handleIframeLoad()
  }, [])

  useEffect(() => {
    if (isLoaded) {
      const iframeElement: any = document?.getElementById('iframe_id');
      console.log("IFRAME--->", iframeElement)
      if (iframeElement) {
        //Font to Root Element
        let rootElement: any = iframeElement?.contentWindow?.document?.getElementsByClassName("EmbedFrame")
        console.log("ROOT ELEMENT--->", iframeElement)
        if (rootElement?.length > 0) {
          rootElement[0].style.fontSize = "16px"
        }
        // get table
        setTimeout(() => {
          let footer = iframeElement?.contentWindow?.document?.getElementsByClassName("EmbedFrame-footer")
          if (footer?.length > 0) {
            footer[0].style.display = "none"
          }

          let table = iframeElement?.contentWindow?.document?.getElementsByTagName("table")
          console.log("TABLE ELEMENT--->", table)
          if (table?.length > 0) {
            console.log("0th TABLE ELEMENT--->", table[0])
            //Font to Table Element
            table[0].style.fontSize = "16px"
          }

        }, 0)
      }
    }
  }, [isLoaded])

  useEffect(() => {
    getIframe()
    clearInterval(intervalId)
    const currentIntervalId = setInterval(() => {
      getIframe()
    }, 30 * 60 * 1000)
    setIntervalId(currentIntervalId)
    return () => { clearInterval(intervalId) }
  }, [selected])

  const getReportsList = (value: any) => {
    if (value) {
      getAllReportsList(value).then((res) => {
        const categoryData = res?.data
        const reportOptions = res?.data?.reports?.map((each: any) => {
          return {
            label: each,
            value: each
          }
        })
        categoryData["reports"] = reportOptions
        setCategory(categoryData)
      })
    }
  }

  const getIframe = () => {
    if (userRole === MocUserRole.MANAGEMENT) {
      getReports("Management Dashboard", "MANAGEMENT", filtersApplied)
        .then((res) => setResults(res?.data))
        .catch((err: any) => setResults({
          "name": "",
          "iframe": "",
          "questionNumber": 11,
          "dashboardNumber": 1
        }))
    }
    else {
      if (selected && category?.categoryName) {
        getReports(selected, category?.categoryName, filtersApplied)
          .then((res) => setResults(res?.data))
          .catch((err: any) => setResults({
            "name": "",
            "iframe": "",
            "questionNumber": 11,
            "dashboardNumber": 1
          }))
      }
    }
  }

  const sendEmail = (() => {
    const iframeLink = results?.iframe
    // setIsLoading(true)
    sendEmailReports(selected, iframeLink, filtersApplied, category?.categoryName, exportoptions, true).then((res: any) => {
      console.log(res);
      // setAnchorEl(null);
      // setExportOptions([
      //   { label: "Send as PDF", checked: false },
      //   { label: "Send as XLSX", checked: false }
      // ])
      setIsLoading(false)
      toggleDisplayToast({ text: "Report will be sent to the registered email ID", type: "success" })
    }).catch((err: any) => {
      setIsLoading(false)
      console.log(err);
      toggleDisplayToast({ text: `Failure in sending report to the registered email ID. Please try again`, type: "error" })
    })
    // }
  })

  const retrieveFiltersFromQueryString = (queryString: any) => {
    let params: any = {};
    //To remove ? from the begining of the string
    queryString = queryString?.replace("?", "")
    //To split at every & symbol
    let keyValuePairs: any = queryString?.split("&")
    if (keyValuePairs?.length) {
      for (let i = 0; i < keyValuePairs?.length; i++) {
        //To split at every = symbol and retrieve the key,value
        let pair: any = keyValuePairs[i]?.split("=")
        if (pair?.length > 1) {
          let key = decodeURIComponent(pair[0])
          let value = decodeURIComponent(pair[1])
          if (key && value) {
            if (params?.hasOwnProperty(key)) {
              if (Array.isArray(params[key])) {
                params[key].push(value);
              } else {
                params[key] = [params[key], value];
              }
            } else {
              params[key] = value;
            }
          }
        }
      }
    }
    return params;
  }

  const downloadFiles = () => {
    let poolingTime: any;
    setDisableDownload(true)
    getPoolingTime()
      .then((res: any) => {
        poolingTime = res?.reportDownloadTimeoutMinites ? res?.reportDownloadTimeoutMinites : 5;
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
    const iframeLink = results?.iframe
    setIsLoading(true)
    const reportNameManipulated = `${selected}_${moment().format('DD-MM-YYYY')}_${moment().format('HH:mm:ss')}`;
    sendEmailReports(reportNameManipulated, iframeLink, filtersApplied, category?.categoryName, exportoptions, false)
      .then((res: any) => {
        toggleDisplayToast({
          text: "Download in Progress...",
          type: "warning",
        });
        getZipUrl(reportNameManipulated, poolingTime)
      })
      .catch((err: any) => {
        console.log(err?.message)
        setIsLoading(false)
        setDisableDownload(false)
        toggleDisplayToast({
          text: "Failed to download Report, Please try again",
          type: "error"
        })
      })
  }

  const getZipUrl = async (reportNameManipulated: any, poolingTime: any) => {
    const intervalIds: any = [];
    let apiSuccess = false;
    const poolingTimeMilisec = poolingTime * 60 * 1000;

    const clearAllIntervals = () => {
      intervalIds?.forEach((id: any) => clearInterval(id));
      intervalIds.length = 0;
    };

    const successCallback = (blobUrl: any) => {
      apiSuccess = true;
      clearAllIntervals();
      setDisableDownload(false);
      setIsLoading(false);
      fileUtils?.downloadFileViaUrlExcel(blobUrl, reportNameManipulated);
      toggleDisplayToast({
        text: "Report downloaded successfully",
        type: "success",
      });
    };

    const intervalId = setInterval(async () => {
      try {
        const res = await getReportData(reportNameManipulated, true);

        if (!apiSuccess && res?.status === "COMPLETED") {
          successCallback(res?.reportUrl);
        } else if (!apiSuccess && res?.status === "FAILED") {
          setDisableDownload(false);
          setIsLoading(false);
          clearAllIntervals();
          if (!apiSuccess) {
            toggleDisplayToast({
              text: "Failed to download Report, Please try again",
              type: "error",
            });
          }
        }
      } catch (err: any) {
        setDisableDownload(false);
        setIsLoading(false);
        clearAllIntervals();
        if (!apiSuccess) {
          toggleDisplayToast({
            text: "Failed to download Report, Please try again",
            type: "error",
          });
        }
      }
    }, 3000);

    intervalIds.push(intervalId);

    if (poolingTimeMilisec > 1000) {
      setTimeout(() => {
        if (!apiSuccess) {
          clearAllIntervals();
          setDisableDownload(false);
          setIsLoading(false);
          toggleDisplayToast({
            text: "Failed to download Report, Please try again",
            type: "error",
          });
        }
      }, poolingTimeMilisec);
    }
  };

  console.log("Updated Filters --->", filtersApplied)

  return (
    <div className="container-wrapper-report" id="container-wrapper-report">
      <div style={{ marginTop: '10px' }}>
        <span className="Heading">Reporting</span>
        <button
          style={{ marginLeft: '20px' }}
          type="button"
          className="btn btn-primary"
          onClick={sendEmail}
          // onClick={(e: any) => handleClick(e)}
          disabled={!results?.name}
        >Send Email</button>

        <button
          style={{ marginLeft: '20px' }}
          type="button"
          className="btn btn-primary"
          onClick={() => {
            if (!disableDownload) {
              downloadFiles()
            }
          }}
          disabled={!results?.name || disableDownload}
        >Download Report</button>
        {/* Export As Functionality */}
      </div>
      {
        userRole === MocUserRole.SYSTEM_ADMIN ?
          <>
            <div className="mt-4">
              <span className="sub-heading">
                Select Category
              </span>
            </div>
            <div className="mt-2">
              <Select
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    border: "1px solid #ccd0e7",
                    borderRadius: "10px"
                  })
                }}
                options={systeAdminCategories}
                onChange={(option: any) => {
                  setIsLoaded(false)
                  setSelectedPersona(option?.value)
                }}
                placeholder="Select Category"
                value={systeAdminCategories?.filter(
                  ({ value }: any) => value === selectedPersona
                )}
              />
            </div>
          </>
          :
          <></>
      }
      {(userRole != MocUserRole.MANAGEMENT && !(userRole === MocUserRole?.SYSTEM_ADMIN && !selectedPersona)) ?
        <>
          <div className="mt-4">
            <span className="sub-heading">
              Select Report Category
            </span>
          </div>
          <div className="mt-2">
            <Select
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={category?.reports}
              onChange={(option: any) => {
                setIsLoaded(false)
                setFiltersApplied({})
                setSelected(option?.value)
              }}
              placeholder="Select Report"
              value={category?.reports?.filter(
                ({ label }: any) => label === selected
              )}
            />
          </div>
        </>
        :
        <></>
      }
      <iframe
        id="iframe_id"
        className="iframe-reports"
        style={{ marginTop: '10px' }}
        src={results?.iframe}
        width="100%"
        height="800"
        title="iframe"
        ref={iframeRef}
        onLoad={handleIframeLoad}
      />
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}

    </div >

  )
}

export default ReportsView
